var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date && _vm.date.length)?_c('span',{class:_vm.styleClass},[(_vm.prefix)?_c('span',{class:['prefix', _vm.prefixStyleClass]},[_vm._v(_vm._s(_vm.prefix)+" \n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.formattedDate)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }